// Libs
import { DialogService, Typography } from 'ui-components';
import { AlertDialogButtonType } from 'ui-components/components/alert-dialog';

/**
 * Show a dialog to tell user an internal server error happened
 */
export const showInternalServerErrorDialog = (): Promise<AlertDialogButtonType> => {
  return DialogService.showInfo({
    title: <span>Mince !</span>,
    body: (
      <div>
        <Typography variant="body2">Quelque chose n&apos;a pas fonctionné correctement.</Typography>
        <br />
        <Typography variant="body2">Rééssayez ultérieurement ou contactez nous si le problème persiste.</Typography>
      </div>
    ),
  });
};

/**
 * Show a dialog to tell user a network error happened
 */
export const showNetworkErrorDialog = (): Promise<AlertDialogButtonType> => {
  return DialogService.showInfo({
    title: <span>Impossible de charger la page.</span>,
    body: (
      <div>
        <Typography variant="body2">Vérifiez votre connexion internet.</Typography>
      </div>
    ),
  });
};

/**
 * Show a dialog to tell user its session has expired
 */
export const showExpiredSessionErrorDialog = (): Promise<AlertDialogButtonType> => {
  return DialogService.showInfo({
    title: <span>Nouvelle identification requise.</span>,
    body: (
      <div>
        <Typography variant="body2">
          Vous avez été déconnecté pour protéger vos données personnelles. Veuillez vous reconnecter.
        </Typography>
      </div>
    ),
  });
};
